import React,{ Component } from 'react';
import FaqCategory from './FaqCategory';
import { filter } from 'lodash';

class FaqCategoryList extends Component {
	constructor(props) {
		super(props);
		this.state = {
			category: null,
		};
	}

	handleScroll(id) {
		const catFaqs = filter(this.props.category, ['categoryName', id]);
		this.setState({ category: catFaqs });
	}

	render() {
		const catDisplay = this.state.category !== null ?
			<FaqCategory category={ this.state.category[0] } /> :
			this.props.category.map((category,index) => <FaqCategory category={ category } key={ index } />);

		return (
			<section className="section-faqs">
				<div className="row">
					<div className="col">
						{ catDisplay }
					</div>
				</div>
			</section>
		);
	}
}

export default FaqCategoryList;


// WEBPACK FOOTER //
// ./src/pages/support/faqs/FaqCategoryList.js